import React, { useState, useRef, useEffect } from 'react';
import { Validaciones } from '@renedelangel/helpers';
import { useSelector } from 'react-redux';
import Tabla from '../../../_layout/masterComponents/Tabla';
import FormularioModal from '../../../_layout/masterComponents/FormularioModal';
import Modal from '../../../_layout/genericComponents/Modal';
import SweetAlert from '../../../_layout/genericComponents/ModalConfirmacion';
import { NetworkError } from "../../../_layout/genericComponents/Metodos";
import Add from "@material-ui/icons/Add";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import SyncIcon from '@material-ui/icons/Sync';
import SaveIcon from '@material-ui/icons/Save';
import EventNoteIcon from '@material-ui/icons/EventNote';
import HistoryIcon from '@material-ui/icons/History';
import SearchIcon from '@material-ui/icons/Search';
import CheckIcon from '@material-ui/icons/Check';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import PersonPinCircleIcon from '@material-ui/icons/PersonPinCircle';
import { RiFileExcel2Fill } from "react-icons/ri";

import { handleFocus, handleErrorInputText, handleModificar, handelAlertEliminar, handleEliminar, handleGuardar } from '../../../_layout/helpers/handles';
import { info, danger, success, primary } from '../../../_layout/helpers/colores';

import { getSeguimientoSiniestros, tablaSeguimientoSiniestros, tablaReporteadorDanios } from '../../../querys/SeguimientoSiniestros';
import { addSeguimientoSiniestros, updateSeguimientoSiniestros, deleteSeguimientoSiniestros } from '../../../mutations/SeguimientoSiniestros';
import { getSeguimientoSemanalSin, getAllSeguimientoSemanalSin, tablaSeguimientoSemanalSin } from '../../../querys/SeguimientoSemanalSin';
import { addSeguimientoSemanalSin, updateSeguimientoSemanalSin, deleteSeguimientoSemanalSin } from '../../../mutations/SeguimientoSemanalSin';
import { seleccionEjercicioSiniestros, seleccionSemanaSiniestros, seleccionEstadoSeguimientoSin, seleccionTipoSeguimientoSin, seleccionUsuarios } from '../../../querys/CatalogosSeguimientoSin';
import { seleccionEmpresa } from '../../../querys/Empresas';
import { tablaSiniestrosReclaAseg } from '../../../querys/SiniestrosReclaAseg';
import { tablaSiniestrosReclaTercero } from '../../../querys/ReclamacionesATerceros';
import { seleccionResponsablesSeguro } from '../../../querys/ResponsablesSeguro';
import * as Permisos from '../Permisos';

import moment from 'moment';
import { urlServidor } from '../../../helpers';

const { trim } = Validaciones;

function ftOpcionesAvance() {
    return Array.from({ length: 20 }, (_, i) => {
        let porcentaje = String((i + 1) * 5);
        return { value: porcentaje, label: `${porcentaje}%` };
    });
}

function ftCeldaEstado(estado, color) {
    if (!color || !/^#[0-9A-Fa-f]{6}$/.test(String(color).trim())) return estado ? String(estado) : "";
    let fondo = String(color).trim();
    let [r, g, b] = [1, 3, 5].map(i => parseInt(fondo.slice(i, i + 2), 16));
    let claro = (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.6;
    return <div style={{
        backgroundColor: fondo,
        color: claro ? "#212121" : "#FFFFFF",
        fontWeight: "bold",
        textAlign: "center",
        padding: "4px 8px",
        borderRadius: "4px",
        whiteSpace: "nowrap"
    }}>{estado}</div>;
}

function SeguimientoSiniestros() {

    const { token, usuario } = useSelector(stDatos => stDatos.login);

    const cleanState = {
        seguimientoSiniestroID: null,
        tipoSeguimientoID: "",
        empresaID: "",
        ejercicioID: "",
        semanaAltaID: "",
        estadoID: "",
        usuarioID: usuario && usuario.usuarioID ? String(usuario.usuarioID) : "",
        responsableID: "",
        personalSeguimiento: "",
        origenID: null,
        origenTipo: "",
        folio: "",
        numSiniestro: "",
        bienDaniado: "",
        descripcion: "",
        montoReclamado: "",
        fechaDanio: moment(),
        fechaReclamacion: "",
        fechaAlta: moment(),
        fechaIngreso: "",
        fechaSeguimiento: "",
        numContacto: "",
        avance: "0"
    };

    const cleanErrorState = {
        tipoSeguimientoID: { error: false, helperText: "" },
        empresaID: { error: false, helperText: "" },
        ejercicioID: { error: false, helperText: "" },
        semanaAltaID: { error: false, helperText: "" },
        estadoID: { error: false, helperText: "" },
        usuarioID: { error: false, helperText: "" },
        responsableID: { error: false, helperText: "" },
        personalSeguimiento: { error: false, helperText: "" },
        folio: { error: false, helperText: "" },
        numSiniestro: { error: false, helperText: "" },
        bienDaniado: { error: false, helperText: "" },
        descripcion: { error: false, helperText: "" },
        montoReclamado: { error: false, helperText: "" },
        fechaDanio: { error: false, helperText: "" },
        fechaReclamacion: { error: false, helperText: "" },
        fechaAlta: { error: false, helperText: "" },
        fechaIngreso: { error: false, helperText: "" },
        fechaSeguimiento: { error: false, helperText: "" },
        numContacto: { error: false, helperText: "" },
        avance: { error: false, helperText: "" }
    };

    const cleanStateSemanal = {
        seguimientoSemanalSinID: null,
        avance: "",
        fechaSeguimiento: moment(),
        personalSeguimiento: "",
        comentario: ""
    };

    const cleanErrorStateSemanal = {
        avance: { error: false, helperText: "" },
        fechaSeguimiento: { error: false, helperText: "" },
        personalSeguimiento: { error: false, helperText: "" },
        comentario: { error: false, helperText: "" }
    };

    const cleanNotificaciones = { mensaje: "", color: null, open: false };

    const [seleccionables, setSeleccionables] = useState({});

    const [stDatos, setState] = useState(cleanState);
    const [errorState, setErrorState] = useState(cleanErrorState);
    const [notificaciones, setNotificaciones] = useState(cleanNotificaciones);
    const [open, setOpen] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [loader, setLoader] = useState(false);
    const [alert, setAlert] = useState(null);
    const [actualizar, setActualizar] = useState(false);

    const [stSemanal, setStateSemanal] = useState(cleanStateSemanal);
    const [errorStateSemanal, setErrorStateSemanal] = useState(cleanErrorStateSemanal);
    const [notificacionesSemanal, setNotificacionesSemanal] = useState(cleanNotificaciones);
    const [openSemanal, setOpenSemanal] = useState(false);
    const [disabledSemanal, setDisabledSemanal] = useState(false);
    const [loaderSemanal, setLoaderSemanal] = useState(false);
    const [actualizarSemanal, setActualizarSemanal] = useState(false);

    const [openVerSemanal, setOpenVerSemanal] = useState(false);
    const [stBuscarReclamo, setBuscarReclamo] = useState(null);
    const [stSeguimientoSiniestroID, setSeguimientoSiniestroID] = useState(-1);
    const [stFolio, setFolio] = useState("");
    const [stFechaInicialPadre, setFechaInicialPadre] = useState("");
    const [stFechaFinalPadre, setFechaFinalPadre] = useState("");
    const [stAvancePadre, setAvancePadre] = useState("");
    const [stActuales, setActuales] = useState({ ejercicioID: "", semanaID: "", numSemana: "", estadoID: "" });
    const [stCatalogosListos, setCatalogosListos] = useState(false);

    const tipoSeguimientoIDRef = useRef(null);
    const empresaIDRef = useRef(null);
    const ejercicioIDRef = useRef(null);
    const estadoIDRef = useRef(null);
    const descripcionRef = useRef(null);

    const comentarioRef = useRef(null);

    let titleModal = `${stDatos.seguimientoSiniestroID ? "Modificar" : "Agregar"} Pendientes de Siniestro`;
    let titleModalSemanal = `${stSemanal.seguimientoSemanalSinID ? "Modificar" : "Agregar"} Seguimiento Semanal`;

    const parametrosPadre = [{ campo: "seguimientoSiniestroID" }, { campo: "folio" }, { campo: "fechaIngreso" }, { campo: "fechaSeguimiento" }, { campo: "avance" }];

    function ftContextoPadre({ seguimientoSiniestroID, folio, fechaIngreso, fechaSeguimiento, avance }) {
        setSeguimientoSiniestroID(seguimientoSiniestroID);
        setFolio(folio);
        setAvancePadre(avance === null || avance === undefined || avance === "" ? "" : `${Number(avance)}%`);
        setFechaInicialPadre(fechaIngreso ? moment(fechaIngreso) : "");
        setFechaFinalPadre(fechaSeguimiento ? moment(fechaSeguimiento) : "");
    }

    let acciones = [{
        accionID: [1, 3],
        icono: Edit,
        color: info,
        descripcion: "Modificar",
        parametros: [{ campo: "seguimientoSiniestroID" }],
        disabled: { multiseleccion: true },
        onClick: (parametros) => handleModificar({
            parametros, token, setState, setOpen, setAlert,
            asyncGet: getSeguimientoSiniestros,
            formatearResultado: [
                { id: "fechaDanio", formato: (data) => data ? moment(data) : "" },
                { id: "fechaReclamacion", formato: (data) => data ? moment(data) : "" },
                { id: "fechaAlta", formato: (data) => data ? moment(data) : "" },
                { id: "fechaIngreso", formato: (data) => data ? moment(data) : "" },
                { id: "fechaSeguimiento", formato: (data) => data ? moment(data) : "" },
                { id: "bienDaniado", formato: (data) => data === null ? "" : data },
                { id: "numContacto", formato: (data) => data === null ? "" : data },
                { id: "montoReclamado", formato: (data) => data === null ? "" : data },
                { id: "responsableID", formato: (data) => data === null || data === undefined ? "" : data },
                { id: "personalSeguimiento", formato: (data) => data === null || data === undefined ? "" : data },
                { id: "origenTipo", formato: (data) => data === null || data === undefined ? "" : data }
            ]
        })
    }, {
        id: "agregarSemanal",
        accionID: [8],
        icono: PlaylistAddIcon,
        color: success,
        descripcion: "Agregar seguimiento",
        parametros: parametrosPadre,
        disabled: { multiseleccion: true },
        onClick: (parametros) => {
            ftContextoPadre(parametros);
            setOpenSemanal(true);
        }
    }, {
        id: "verSemanal",
        accionID: [8],
        icono: HistoryIcon,
        color: primary,
        descripcion: "Historial de seguimiento",
        parametros: parametrosPadre,
        disabled: { multiseleccion: true },
        onClick: (parametros) => {
            ftContextoPadre(parametros);
            setActualizarSemanal(!actualizarSemanal);
            setOpenVerSemanal(true);
        }
    }, {
        id: "eliminar",
        accionID: [4],
        icono: Close,
        color: danger,
        descripcion: "Eliminar",
        parametros: [{ campo: "seguimientoSiniestroID" }, { campo: "folio" }],
        disabled: { multiseleccion: true },
        onClick: ({ seguimientoSiniestroID, folio }) => handelAlertEliminar({
            setAlert,
            mensaje: ` el seguimiento ${folio ? folio : ""}`,
            onCancel: () => setAlert(null),
            onConfirm: () => handleEliminar({
                token, setAlert, setActualizar, actualizar,
                parametros: { seguimientoSiniestroID }, asyncDelete: deleteSeguimientoSiniestros
            })
        })
    }];

    // Último filtro que usó la tabla (sin la paginación), para el Excel
    const refFiltroTabla = useRef({});

    async function ftTablaSeguimientos(variables, token) {
        refFiltroTabla.current = variables && variables.filtro ? variables.filtro : {};
        return tablaSeguimientoSiniestros(variables, token);
    }

    async function ftDescargarExcel() {
        setAlert({
            descripcion: "Generando el Excel del seguimiento de siniestros",
            title: "Espere...",
            tipo: success,
            showConfirm: false,
            showCancel: false
        });
        try {
            let { pagina, limite, count, ...filtro } = refFiltroTabla.current || {};
            let formdata = new FormData();
            formdata.append("filtro", JSON.stringify(filtro));
            // Fecha del informe en el resumen (p. ej. 03/nov/2026 17:00), la del equipo del usuario
            let ahora = moment();
            let meses = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
            formdata.append("fechaHora", `${ahora.format("DD")}/${meses[ahora.month()]}/${ahora.format("YYYY HH:mm")}`);

            let respuesta = await fetch(`${urlServidor}/service/reportes/SeguimientoSiniestrosExcel`, {
                method: 'POST',
                headers: { token },
                body: formdata
            });
            if (!respuesta.ok) {
                let { mensaje } = await respuesta.json().catch(() => ({}));
                throw new Error(mensaje || "No se pudo generar el Excel");
            }
            let archivo = await respuesta.blob();
            let url = window.URL.createObjectURL(archivo);
            let a = document.createElement('a');
            a.href = url;
            a.download = `Seguimiento Siniestros ${moment().format("DD-MM-YYYY")}.xlsx`;
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            setAlert(null);
        } catch ({ message }) {
            setAlert({
                descripcion: `No se pudo generar el Excel: ${NetworkError(message)}`,
                title: "¡Una disculpa!",
                tipo: danger,
                msjConfirmacion: "Aceptar",
                onConfirm: () => setAlert(null),
                showCancel: false
            });
        }
    }

    let botones = [{
        accionID: [2],
        icono: Add,
        color: success,
        descripcion: "Agregar",
        onClick: () => {
            setState(stDatos => ({
                ...stDatos,
                ejercicioID: stActuales.ejercicioID,
                semanaAltaID: stActuales.semanaID,
                estadoID: stActuales.estadoID
            }));
            setOpen(true);
        },
        disabled: { multiseleccion: true }
    }, {
        icono: SyncIcon,
        color: info,
        descripcion: "Actualizar",
        onClick: () => setActualizar(!actualizar),
        disabled: { multiseleccion: true }
    }, {
        icono: RiFileExcel2Fill,
        color: success,
        descripcion: "Excel Seguimiento",
        onClick: () => ftDescargarExcel(),
        disabled: { multiseleccion: true }
    }];

    const infoTabla = {
        botones,
        acciones,
        accionesEffect: [{ botones: ["eliminar"], ocultar: (fila) => Number(fila && fila.avance ? fila.avance.value : 0) > 0 }],
        actualizar,
        id: "seguimientoSiniestroID",
        color: primary,
        title: "Seguimiento Pendientes Siniestros",
        iconTable: <PersonPinCircleIcon />,
        headers: [
            { variable: "seguimientoSiniestroID", descripcion: "ID", hide: true },
            { variable: "tipoSeguimientoID", descripcion: "tipoSeguimientoID", hide: true },
            { variable: "empresaID", descripcion: "empresaID", hide: true },
            { variable: "responsableID", descripcion: "responsableID", hide: true },
            { variable: "ejercicioID", descripcion: "ejercicioID", hide: true },
            { variable: "estadoID", descripcion: "estadoID", hide: true },
            { variable: "estadoColor", descripcion: "estadoColor", hide: true },
            { variable: "folio", descripcion: "Folio" },
            { variable: "empresa", descripcion: "Empresa" },
            { variable: "tipoSeguimiento", descripcion: "Categoría" },
            { variable: "numSiniestro", descripcion: "No. Siniestro" },
            { variable: "bienDaniado", descripcion: "Bien Dañado" },
            { variable: "montoReclamado", descripcion: "Reclamación $" },
            { variable: "fechaDanio", descripcion: "Fecha del Daño" },
            { variable: "fechaReclamacion", descripcion: "Fecha de Reclamación" },
            { variable: "fechaIngreso", descripcion: "Fecha de Ingreso" },
            { variable: "fechaSeguimiento", descripcion: "Fecha de Seguimiento" },
            { variable: "diasSeguimiento", descripcion: "Días Transcurridos" },
            { variable: "avance", descripcion: "% de Gestión" },
            { variable: "responsable", descripcion: "Responsable" },
            { variable: "personalSeguimiento", descripcion: "Personal de Seguimiento" },
            { variable: "descripcion", descripcion: "Seguimiento" },
            { variable: "numContacto", descripcion: "Núm. Contacto" },
            { variable: "ejercicio", descripcion: "Ejercicio" },
            { variable: "numSemanaAlta", descripcion: "Semana" },
            { variable: "estado", descripcion: "Estado" }
        ],
        responsiveTitle: ["folio", "empresa", "estado"],
        filter: [
            { campo: "folio", variable: "folio", placeholder: "Capture el N°" },
            { campo: "numSiniestro", variable: "numSiniestro", placeholder: "Capture el no. de siniestro" },
            { campo: "bienDaniado", variable: "bienDaniado", placeholder: "Capture el bien dañado" }
        ],
        selectFilter: [
            {
                campo: "ejercicioID", title: "Ejercicio",
                // Por defecto el ejercicio actual
                retorna: "number", limpiarFiltro: "Todos",
                defaultValue: stActuales.ejercicioID,
                data: seleccionables.Ejercicios ? seleccionables.Ejercicios : [], grid: { md: 3, lg: 3 }
            },
            {
                campo: "tipoSeguimientoID", title: "Categoría",
                retorna: "number", limpiarFiltro: "Todas",
                data: seleccionables.Tipos ? seleccionables.Tipos : [], grid: { md: 3, lg: 3 }
            },
            {
                campo: "empresaID", title: "Empresa",
                retorna: "number", limpiarFiltro: "Todas",
                data: seleccionables.Empresas ? seleccionables.Empresas : [], grid: { md: 3, lg: 3 }
            },
            {
                campo: "estadoID", title: "Estado",
                retorna: "number", limpiarFiltro: "Todos",
                data: seleccionables.Estados ? seleccionables.Estados : [], grid: { md: 3, lg: 3 }
            }
        ],
        formato: [
            { columnas: ["fechaDanio", "fechaReclamacion", "fechaIngreso", "fechaSeguimiento", "fechaAlta"], tipo: "fecha", onlyDate: true },
            { columnas: ["montoReclamado"], tipo: "moneda" },
            // Se formatean aparte para que el 0 se vea (la tabla deja vacío un valor 0)
            { columnas: ["avance"], tipo: "custom", callback: (valor) => valor === null || valor === undefined || valor === "" ? "" : `${Number(valor)}%` },
            { columnas: ["diasSeguimiento"], tipo: "custom", callback: (valor) => valor === null || valor === undefined || valor === "" ? "" : String(valor) },
            { columnas: ["estado"], tipo: "custom", callback: (valor, row) => ftCeldaEstado(valor, row && row.estadoColor ? row.estadoColor.value : "") }
        ],
        alineacion: [{ columnas: [0, 1, 2, 3, 4], alineacion: "left" }]
    };

    const inputs = [
        {
            disabled,
            id: "responsableID",
            value: stDatos.responsableID,
            error: errorState.responsableID.error,
            success: stDatos.responsableID && !errorState.responsableID.error ? true : undefined,
            helperText: errorState.responsableID.helperText,
            title: "Responsable",
            placeholder: "Seleccione el responsable",
            tipo: "select",
            data: seleccionables.Responsables ? seleccionables.Responsables : [],
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => handleChange(value, "responsableID")
        },
        {
            disabled,
            id: "empresaID",
            value: stDatos.empresaID,
            error: errorState.empresaID.error,
            success: stDatos.empresaID && !errorState.empresaID.error ? true : undefined,
            helperText: errorState.empresaID.helperText,
            inputRef: empresaIDRef,
            title: "Empresa *",
            // Con reporteador o reclamos se puede quitar la empresa para buscar el origen en todas;
            // al seleccionarlo con la lupa se pone la empresa del reporte o reclamo
            ...(ftTipoReclamo() ? {} : { placeholder: "Seleccione la empresa" }),
            tipo: "select",
            data: [
                ...(ftTipoReclamo() ? [{ value: "", label: "Sin empresa (buscar en todas)" }] : []),
                ...(seleccionables.Empresas ? seleccionables.Empresas : [])
            ],
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => handleChange(value, "empresaID")
        },
        {
            disabled,
            id: "tipoSeguimientoID",
            value: stDatos.tipoSeguimientoID,
            error: errorState.tipoSeguimientoID.error,
            success: stDatos.tipoSeguimientoID && !errorState.tipoSeguimientoID.error ? true : undefined,
            helperText: errorState.tipoSeguimientoID.helperText,
            inputRef: tipoSeguimientoIDRef,
            title: "Categoría Seguimiento *",
            placeholder: "Categoría Seguimiento *",
            tipo: "select",
            data: seleccionables.Tipos ? seleccionables.Tipos : [],
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => handleChange(value, "tipoSeguimientoID")
        },
        {
            disabled,
            id: "estadoID",
            value: stDatos.estadoID,
            error: errorState.estadoID.error,
            success: stDatos.estadoID && !errorState.estadoID.error ? true : undefined,
            helperText: errorState.estadoID.helperText,
            inputRef: estadoIDRef,
            title: "Estado Seguimiento *",
            placeholder: "Seleccione el estado",
            tipo: "select",
            data: seleccionables.Estados ? seleccionables.Estados : [],
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => handleChange(value, "estadoID")
        },
        {
            disabled,
            id: "numSiniestro",
            value: stDatos.numSiniestro,
            error: errorState.numSiniestro.error,
            success: stDatos.numSiniestro && !errorState.numSiniestro.error ? true : undefined,
            helperText: errorState.numSiniestro.helperText,
            title: "No. de Siniestro",
            placeholder: ftTipoReclamo() ? "Capture o busque el siniestro" : "Capture el número de siniestro",
            ...(ftTipoReclamo() ? {
                icono: <SearchIcon />,
                onClickIcono: () => { if (!disabled) setBuscarReclamo(ftTipoReclamo()); }
            } : {}),
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => {
                handleChange(value, "numSiniestro");
                setState(stDatos => ({ ...stDatos, origenID: null, origenTipo: "" }));
            },
            onKeyDown: () => { return; }
        },
        {
            disabled,
            id: "bienDaniado",
            value: stDatos.bienDaniado,
            error: errorState.bienDaniado.error,
            success: stDatos.bienDaniado && !errorState.bienDaniado.error ? true : undefined,
            helperText: errorState.bienDaniado.helperText,
            title: "Bien Dañado",
            placeholder: "Capture el bien dañado",
            grid: { md: 6, lg: 6 },
            onChange: ({ target: { value } }) => handleChange(value, "bienDaniado"),
            onKeyDown: () => { return; }
        },
        {
            disabled,
            id: "montoReclamado",
            value: stDatos.montoReclamado,
            error: errorState.montoReclamado.error,
            success: stDatos.montoReclamado && !errorState.montoReclamado.error ? true : undefined,
            helperText: errorState.montoReclamado.helperText,
            title: "Reclamación $",
            placeholder: "0.00",
            textAlign: "right",
            formatoImportes: true,
            icono: <span>$</span>,
            posicionIcono: "start",
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => { (!isNaN(Number(value)) || value === "") && handleChange(value, "montoReclamado") },
            onKeyDown: () => { return; }
        },
        {
            disabled,
            id: "fechaDanio",
            value: stDatos.fechaDanio,
            error: errorState.fechaDanio.error,
            success: stDatos.fechaDanio && !errorState.fechaDanio.error ? true : undefined,
            helperText: errorState.fechaDanio.helperText,
            title: "Fecha del Daño",
            placeholder: "Fecha del daño",
            tipo: "datetimepicker",
            onlyDate: true,
            timeFormat: false,
            grid: { md: 3, lg: 3 },
            onChange: (value) => { if (typeof value !== "object") return; handleChange(value, "fechaDanio") }
        },
        {
            disabled,
            id: "fechaReclamacion",
            value: stDatos.fechaReclamacion,
            error: errorState.fechaReclamacion.error,
            success: stDatos.fechaReclamacion && !errorState.fechaReclamacion.error ? true : undefined,
            helperText: errorState.fechaReclamacion.helperText,
            title: "Fecha de Reclamación",
            placeholder: "Fecha de reclamación",
            tipo: "datetimepicker",
            onlyDate: true,
            timeFormat: false,
            grid: { md: 3, lg: 3 },
            onChange: (value) => { if (typeof value !== "object") return; handleChange(value, "fechaReclamacion") }
        },
        {
            disabled,
            id: "fechaIngreso",
            value: stDatos.fechaIngreso,
            error: errorState.fechaIngreso.error,
            success: stDatos.fechaIngreso && !errorState.fechaIngreso.error ? true : undefined,
            helperText: errorState.fechaIngreso.helperText,
            title: "Fecha de Ingreso *",
            placeholder: "Fecha de ingreso",
            tipo: "datetimepicker",
            onlyDate: true,
            timeFormat: false,
            grid: { md: 3, lg: 3 },
            onChange: (value) => { if (typeof value !== "object") return; handleChange(value, "fechaIngreso") }
        },
        {
            disabled: true,
            id: "fechaSeguimiento",
            value: stDatos.fechaSeguimiento,
            error: errorState.fechaSeguimiento.error,
            success: stDatos.fechaSeguimiento && !errorState.fechaSeguimiento.error ? true : undefined,
            helperText: errorState.fechaSeguimiento.helperText,
            title: "Fecha Ultimo Seguimiento",
            placeholder: "Fecha Ultimo Seguimiento",
            tipo: "datetimepicker",
            onlyDate: true,
            timeFormat: false,
            grid: { md: 3, lg: 3 },
            onChange: (value) => { if (typeof value !== "object") return; handleChange(value, "fechaSeguimiento") }
        },
        {
            disabled,
            id: "descripcion",
            multiline: true,
            value: stDatos.descripcion,
            error: errorState.descripcion.error,
            success: stDatos.descripcion && !errorState.descripcion.error ? true : undefined,
            helperText: errorState.descripcion.helperText,
            inputRef: descripcionRef,
            title: "Seguimiento",
            placeholder: "Se llena con el último seguimiento semanal",
            grid: { md: 9, lg: 9 },
            onChange: ({ target: { value } }) => handleChange(value, "descripcion"),
            onKeyDown: () => { return; }
        },
        {
            disabled,
            id: "personalSeguimiento",
            value: stDatos.personalSeguimiento,
            error: errorState.personalSeguimiento.error,
            success: stDatos.personalSeguimiento && !errorState.personalSeguimiento.error ? true : undefined,
            helperText: errorState.personalSeguimiento.helperText,
            title: "Personal de Seguimiento",
            placeholder: "Capture quién da el seguimiento",
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => handleChange(value, "personalSeguimiento"),
            onKeyDown: () => { return; }
        },
        {
            disabled,
            id: "numContacto",
            value: stDatos.numContacto,
            error: errorState.numContacto.error,
            success: stDatos.numContacto && !errorState.numContacto.error ? true : undefined,
            helperText: errorState.numContacto.helperText,
            title: "Núm. de Contacto",
            placeholder: "Capture el número de contacto",
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => handleChange(value, "numContacto"),
            onKeyDown: () => { return; }
        },
        {
            // Con origen, el folio es el del reporte o reclamo y no se captura
            disabled: disabled || !!stDatos.origenID,
            id: "folio",
            value: stDatos.folio,
            error: errorState.folio.error,
            success: stDatos.folio && !errorState.folio.error ? true : undefined,
            helperText: errorState.folio.helperText,
            title: "Folio",
            placeholder: stDatos.origenID ? "Se toma del origen" : "Capture el Folio",
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => handleChange(value, "folio"),
            onKeyDown: () => { return; }
        },
        {
            disabled: true,
            id: "origenTipo",
            value: stDatos.origenTipo,
            title: "Origen",
            placeholder: "Se llena al seleccionar un reclamo",
            grid: { md: 3, lg: 3 },
            onChange: () => { return; },
            onKeyDown: () => { return; }
        },
        {
            disabled: true,
            id: "avance",
            value: stDatos.avance,
            error: errorState.avance.error,
            success: stDatos.avance && !errorState.avance.error ? true : undefined,
            helperText: errorState.avance.helperText,
            title: "% de Gestión",
            placeholder: "Se calcula de los seguimientos",
            textAlign: "right",
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => { (!isNaN(Number(value)) || value === "") && handleChange(value, "avance") },
            onKeyDown: () => { return; }
        },
    ];

    let accionesFormulario = [{
        accionID: stDatos.seguimientoSiniestroID ? [3] : [2],
        loader,
        disabled,
        icono: SaveIcon,
        color: info,
        descripcion: "Guardar",
        onClick: () => handleGuardar({
            setLoader,
            setDisabled,
            setActualizar,
            actualizar,
            setNotificaciones,
            handleClose,
            handleFocus,
            refFocus: empresaIDRef,
            mensajeCorrecto: `El seguimiento se ${stDatos.seguimientoSiniestroID ? "actualizó" : "agregó"} correctamente`,
            asyncCallback: ftGuardar
        })
    }, {
        disabled,
        icono: Close,
        color: danger,
        descripcion: "Cancelar",
        onClick: handleClose
    }];

    const accionesSemanal = [{
        icono: Edit,
        color: info,
        descripcion: "Modificar",
        parametros: [{ campo: "seguimientoSemanalSinID" }],
        disabled: { multiseleccion: true },
        onClick: (parametros) => handleModificar({
            parametros, token, setState: setStateSemanal, setOpen: setOpenSemanal, setAlert,
            asyncGet: getSeguimientoSemanalSin,
            formatearResultado: [
                { id: "fechaSeguimiento", formato: (data) => data ? moment(data) : "" },
                { id: "comentario", formato: (data) => data === null ? "" : data },
                { id: "personalSeguimiento", formato: (data) => data === null ? "" : data },
                { id: "avance", formato: (data) => data === null || data === undefined ? "" : String(Number(data)) }
            ]
        })
    }, {
        icono: Close,
        color: danger,
        descripcion: "Eliminar",
        parametros: [{ campo: "seguimientoSemanalSinID" }, { campo: "numSemana" }],
        disabled: { multiseleccion: true },
        onClick: ({ seguimientoSemanalSinID, numSemana }) => handelAlertEliminar({
            setAlert,
            mensaje: ` el seguimiento de la semana ${numSemana}`,
            onCancel: () => setAlert(null),
            onConfirm: () => handleEliminar({
                token, setAlert, setActualizar: setActualizarSemanal, actualizar: actualizarSemanal,
                parametros: { seguimientoSemanalSinID }, asyncDelete: deleteSeguimientoSemanalSin
            })
        })
    }];

    // Excel del historial de seguimiento (semanales) del pendiente abierto
    async function ftDescargarExcelSemanal() {
        setAlert({
            descripcion: "Generando el Excel del historial de seguimiento",
            title: "Espere...",
            tipo: success,
            showConfirm: false,
            showCancel: false
        });
        try {
            let formdata = new FormData();
            formdata.append("seguimientoSiniestroID", stSeguimientoSiniestroID);

            let respuesta = await fetch(`${urlServidor}/service/reportes/SeguimientoSemanalSiniestrosExcel`, {
                method: 'POST',
                headers: { token },
                body: formdata
            });
            if (!respuesta.ok) {
                let { mensaje } = await respuesta.json().catch(() => ({}));
                throw new Error(mensaje || "No se pudo generar el Excel");
            }
            let archivo = await respuesta.blob();
            let url = window.URL.createObjectURL(archivo);
            let a = document.createElement('a');
            a.href = url;
            a.download = `Historial de Seguimiento ${stFolio ? stFolio + " " : ""}${moment().format("DD-MM-YYYY")}.xlsx`;
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            setAlert(null);
        } catch ({ message }) {
            setAlert({
                descripcion: `No se pudo generar el Excel: ${NetworkError(message)}`,
                title: "¡Una disculpa!",
                tipo: danger,
                msjConfirmacion: "Aceptar",
                onConfirm: () => setAlert(null),
                showCancel: false
            });
        }
    }

    const botonesSemanal = [{
        icono: SyncIcon,
        color: info,
        descripcion: "Actualizar",
        onClick: () => setActualizarSemanal(!actualizarSemanal),
        disabled: { multiseleccion: true }
    }, {
        icono: RiFileExcel2Fill,
        color: success,
        descripcion: "Generar Excel",
        onClick: () => ftDescargarExcelSemanal(),
        disabled: { multiseleccion: true }
    }];

    function ftTipoReclamo() {
        let tipo = (seleccionables.Tipos || []).find(({ value }) => value !== null && String(value) === String(stDatos.tipoSeguimientoID));
        let nombre = tipo ? String(tipo.label || "").trim().toUpperCase() : "";
        if (nombre === "RECLAMOS A LA ASEGURADORA") return "aseguradora";
        if (nombre === "RECLAMOS A TERCEROS") return "terceros";
        if (nombre === "REPORTEADOR" || nombre === "REPORTEADOR DE DAÑOS") return "reporteador";
        return null;
    }

    const camposReclamo = {
        aseguradora: { id: "siniesReclAsegID", numero: "siniestro", bien: "equipoBienAfectado", titulo: "Reclamos a la Aseguradora", origenTipo: "RECLAMOS A ASEGURADORAS", asyncData: tablaSiniestrosReclaAseg },
        terceros: { id: "siniesReclTercerosID", numero: "noSiniestro", bien: "bienAfectado", titulo: "Reclamos a Terceros", origenTipo: "RECLAMACIONES A TERCEROS", asyncData: tablaSiniestrosReclaTercero },
        reporteador: { id: "reporteDaniosID", numero: "folioInterno", bien: "descripBreve", titulo: "Reporteador de Daños", origenTipo: "REPORTEADOR DE DAÑOS", asyncData: tablaReporteadorDanios }
    };

    function ftInfoTablaReclamos(tipo) {
        const r = camposReclamo[tipo];
        if (tipo === "reporteador") return {
            botones: [],
            acciones: [{
                icono: CheckIcon,
                color: success,
                descripcion: "Seleccionar",
                parametros: [
                    { campo: "reporteDaniosID", variable: "reclamoID" }, { campo: "folioInterno" },
                    { campo: "descripBreve", variable: "bien" }, { campo: "fechaEvento", variable: "fechaAfectado" }, { campo: "empresaID" }
                ],
                disabled: { multiseleccion: true },
                onClick: (reporte) => ftSeleccionarReclamo(reporte)
            }],
            id: r.id,
            color: primary,
            title: r.titulo,
            iconTable: <SearchIcon />,
            headers: [
                { variable: "reporteDaniosID", descripcion: "ID", hide: true },
                { variable: "empresaID", descripcion: "empresaID", hide: true },
                { variable: "folioInterno", descripcion: "Folio Interno" },
                { variable: "estatus", descripcion: "Estatus" },
                { variable: "descripBreve", descripcion: "Bien Dañado" },
                { variable: "fechaEvento", descripcion: "Fecha del Evento" },
                { variable: "lugarEvento", descripcion: "Lugar del Evento" },
                { variable: "danioOcasioA", descripcion: "Daño ocasionado a" }
            ],
            responsiveTitle: ["folioInterno", "descripBreve"],
            filter: [
                { campo: "folioInterno", variable: "folioInterno", placeholder: "Capture el folio" },
                { campo: "lugarEvento", variable: "lugarEvento", placeholder: "Capture el lugar del evento" }
            ],
            formato: [
                { columnas: ["fechaEvento"], tipo: "fecha", onlyDate: true }
            ],
            alineacion: [{ columnas: [0, 1, 2, 3, 4], alineacion: "left" }]
        };
        return {
            botones: [],
            acciones: [{
                icono: CheckIcon,
                color: success,
                descripcion: "Seleccionar",
                parametros: [
                    { campo: r.id, variable: "reclamoID" }, { campo: r.numero, variable: "numero" }, { campo: "folioInterno" },
                    { campo: r.bien, variable: "bien" }, { campo: "fechaAfectado" }, { campo: "fechaReclamacion" }, { campo: "descripEvento" },
                    { campo: "empresaID" }
                ],
                disabled: { multiseleccion: true },
                onClick: (reclamo) => ftSeleccionarReclamo(reclamo)
            }],
            id: r.id,
            color: primary,
            title: r.titulo,
            iconTable: <SearchIcon />,
            headers: [
                { variable: r.id, descripcion: r.id, hide: true },
                { variable: "empresaID", descripcion: "empresaID", hide: true },
                { variable: r.numero, descripcion: "No. Siniestro", hide: true },
                { variable: "folioInterno", descripcion: "Folio Reclamo" },
                { variable: r.bien, descripcion: "Bien Dañado" },
                { variable: "fechaAfectado", descripcion: "Fecha del Daño" },
                { variable: "fechaReclamacion", descripcion: "Fecha de Reclamación" },
                { variable: "descripEvento", descripcion: "Descripción del Evento" }
            ],
            responsiveTitle: ["folioInterno", r.bien],
            filter: [
                { campo: r.bien, variable: r.bien, placeholder: "Capture el bien dañado" },
                { campo: "descripEvento", variable: "descripEvento", placeholder: "Capture parte del evento" }
            ],
            formato: [
                { columnas: ["fechaAfectado", "fechaReclamacion"], tipo: "fecha", onlyDate: true }
            ],
            alineacion: [{ columnas: [0, 1, 2, 4], alineacion: "left" }]
        };
    }

    // El folio es el del reporte o reclamo de origen; el No. de Siniestro, el del reclamo o N/A si no tiene
    // (el reporte de daños no tiene número de siniestro). Igual que spSeguimientoSiniestrosDeOrigen
    function ftSeleccionarReclamo({ reclamoID, numero, folioInterno, bien, fechaAfectado, fechaReclamacion, empresaID }) {
        const texto = (valor) => valor === null || valor === undefined ? "" : String(valor).trim();
        setState(stDatos => ({
            ...stDatos,
            origenID: reclamoID ? String(reclamoID) : null,
            origenTipo: reclamoID && camposReclamo[stBuscarReclamo] ? camposReclamo[stBuscarReclamo].origenTipo : "",
            numSiniestro: texto(numero) || "N/A",
            folio: texto(folioInterno),
            bienDaniado: texto(bien),
            fechaDanio: fechaAfectado ? moment(fechaAfectado) : stDatos.fechaDanio,
            fechaReclamacion: fechaReclamacion ? moment(fechaReclamacion) : "",
            empresaID: empresaID ? String(empresaID) : stDatos.empresaID
        }));
        setErrorState(errorState => ({
            ...errorState,
            numSiniestro: { error: false, helperText: "" },
            folio: { error: false, helperText: "" },
            bienDaniado: { error: false, helperText: "" },
            fechaDanio: { error: false, helperText: "" },
            fechaReclamacion: { error: false, helperText: "" },
            ...(empresaID ? { empresaID: { error: false, helperText: "" } } : {})
        }));
        setBuscarReclamo(null);
    }

    const infoTablaSemanal = {
        botones: botonesSemanal,
        acciones: accionesSemanal,
        actualizar: actualizarSemanal,
        id: "seguimientoSemanalSinID",
        color: primary,
        title: `Seguimiento Semanal ${stFolio ? "(" + stFolio + ")" : ""}`,
        iconTable: <EventNoteIcon />,
        headers: [
            { variable: "seguimientoSemanalSinID", descripcion: "ID", hide: true },
            { variable: "seguimientoSiniestroID", descripcion: "seguimientoSiniestroID", hide: true },
            { variable: "avance", descripcion: "% de Gestión" },
            { variable: "comentario", descripcion: "Seguimiento" },
            { variable: "fechaSeguimiento", descripcion: "Fecha de Seguimiento" },
            { variable: "personalSeguimiento", descripcion: "Personal" },
            { variable: "usuario", descripcion: "Capturó" },
            { variable: "altaSeguimiento", descripcion: "Alta del Seguimiento" }
        ],
        responsiveTitle: ["fechaSeguimiento", "comentario"],
        formato: [
            { columnas: ["fechaSeguimiento"], tipo: "fecha", onlyDate: true },
            { columnas: ["altaSeguimiento"], tipo: "fecha" },
            { columnas: ["avance"], tipo: "porcentaje", simbolo: "%" }
        ],
        alineacion: [{ columnas: [0, 1, 2], alineacion: "left" }]
    };

    const inputsSemanal = [
        {
            disabled: true,
            id: "fechaInicialPadre",
            value: stFechaInicialPadre,
            title: "Fecha de Ingreso",
            placeholder: "Fecha de ingreso",
            tipo: "datetimepicker",
            onlyDate: true,
            timeFormat: false,
            grid: { md: 3, lg: 3 },
            onChange: () => { return; }
        },
        {
            disabled: true,
            id: "fechaFinalPadre",
            value: stFechaFinalPadre,
            title: "Último Seguimiento",
            placeholder: "Último seguimiento",
            tipo: "datetimepicker",
            onlyDate: true,
            timeFormat: false,
            grid: { md: 3, lg: 3 },
            onChange: () => { return; }
        },
        {
            disabled: disabledSemanal,
            id: "fechaSeguimiento",
            value: stSemanal.fechaSeguimiento,
            error: errorStateSemanal.fechaSeguimiento.error,
            success: stSemanal.fechaSeguimiento && !errorStateSemanal.fechaSeguimiento.error ? true : undefined,
            helperText: errorStateSemanal.fechaSeguimiento.helperText,
            title: "Fecha de Seguimiento *",
            placeholder: "Fecha de seguimiento",
            tipo: "datetimepicker",
            onlyDate: true,
            timeFormat: false,
            grid: { md: 3, lg: 3 },
            onChange: (value) => { if (typeof value !== "object") return; handleChangeSemanal(value, "fechaSeguimiento") }
        },
        {
            disabled: true,
            id: "semanaSeguimiento",
            value: ftSemanaDeFecha(stSemanal.fechaSeguimiento),
            title: "Semana",
            placeholder: "Semana de la fecha de seguimiento",
            grid: { md: 3, lg: 3 },
            onChange: () => { return; },
            onKeyDown: () => { return; }
        },
        {
            disabled: disabledSemanal,
            id: "comentario",
            multiline: true,
            value: stSemanal.comentario,
            error: errorStateSemanal.comentario.error,
            success: stSemanal.comentario && !errorStateSemanal.comentario.error ? true : undefined,
            helperText: errorStateSemanal.comentario.helperText,
            inputRef: comentarioRef,
            title: "Seguimiento *",
            placeholder: "Capture el seguimiento de la semana",
            grid: { md: 12, lg: 12 },
            onChange: ({ target: { value } }) => handleChangeSemanal(value, "comentario"),
            onKeyDown: () => { return; }
        },
        {
            disabled: disabledSemanal,
            id: "personalSeguimiento",
            value: stSemanal.personalSeguimiento,
            error: errorStateSemanal.personalSeguimiento.error,
            success: stSemanal.personalSeguimiento && !errorStateSemanal.personalSeguimiento.error ? true : undefined,
            helperText: errorStateSemanal.personalSeguimiento.helperText,
            title: "Personal que dio Seguimiento",
            placeholder: "Capture el nombre del personal",
            grid: { md: 5, lg: 5 },
            onChange: ({ target: { value } }) => handleChangeSemanal(value, "personalSeguimiento"),
            onKeyDown: () => { return; }
        },
        {
            // Solo informativo: el % de gestión que lleva el pendiente
            disabled: true,
            id: "avancePadre",
            value: stAvancePadre,
            title: "Avance actual",
            placeholder: "Avance actual",
            grid: { md: 3, lg: 3 },
            onChange: () => { return; },
            onKeyDown: () => { return; }
        },
        {
            disabled: disabledSemanal,
            id: "avance",
            value: stSemanal.avance,
            error: errorStateSemanal.avance.error,
            success: stSemanal.avance && !errorStateSemanal.avance.error ? true : undefined,
            helperText: errorStateSemanal.avance.helperText,
            title: "% de Gestión *",
            placeholder: "Seleccione o escriba el %",
            tipo: "autocomplete",
            addNewValue: true,
            data: ftOpcionesAvance(),
            grid: { md: 4, lg: 4 },
            onChange: (opcion) => {
                let valor = opcion && opcion.value !== null && opcion.value !== undefined ? String(opcion.value).replace("%", "").trim() : "";
                if (valor === "" || !isNaN(Number(valor))) handleChangeSemanal(valor, "avance");
            }
        },
    ];

    const accionesFormularioSemanal = [{
        loader: loaderSemanal,
        disabled: disabledSemanal,
        icono: SaveIcon,
        color: info,
        descripcion: "Guardar",
        onClick: () => handleGuardar({
            setLoader: setLoaderSemanal,
            setDisabled: setDisabledSemanal,
            setActualizar: setActualizarSemanal,
            actualizar: actualizarSemanal,
            setNotificaciones: setNotificacionesSemanal,
            handleClose: handleCloseSemanal,
            handleFocus,
            refFocus: comentarioRef,
            mensajeCorrecto: `El seguimiento semanal se ${stSemanal.seguimientoSemanalSinID ? "actualizó" : "agregó"} correctamente`,
            asyncCallback: ftGuardarSemanal
        })
    }, {
        disabled: disabledSemanal,
        icono: Close,
        color: danger,
        descripcion: "Cancelar",
        onClick: handleCloseSemanal
    }];

    function ftVigentesALaFecha(Ejercicios = [], Semanas = []) {
        let hoy = moment();
        let vigente = ({ fechaInicio, fechaFin }) => fechaInicio && fechaFin &&
            hoy.isBetween(moment(fechaInicio), moment(fechaFin), 'day', '[]');

        let ejercicio = Ejercicios.find(vigente);
        let semanas = ejercicio
            ? Semanas.filter(({ ejercicioID }) => Number(ejercicioID) === Number(ejercicio.value))
            : Semanas;
        let semana = semanas.find(vigente);

        if (!semana && ejercicio) {
            semana = semanas
                .filter(({ fechaFin }) => fechaFin && moment(fechaFin).isSameOrBefore(hoy, 'day'))
                .reduce((anterior, actual) => !anterior || moment(actual.fechaFin).isAfter(moment(anterior.fechaFin))
                    ? actual
                    : anterior, null);
        }

        return {
            ejercicioID: ejercicio ? ejercicio.value : "",
            semanaID: semana ? semana.value : "",
            numSemana: semana ? semana.numSemana : ""
        };
    }

    // Semana (de lunes a domingo) en la que cae la fecha, dentro del ejercicio que contiene esa fecha;
    // solo es informativa, no se guarda
    function ftSemanaDeFecha(fecha) {
        if (!fecha || !moment(fecha).isValid()) return "";
        let dia = moment(fecha);
        let dentro = ({ fechaInicio, fechaFin }) => fechaInicio && fechaFin &&
            dia.isBetween(moment(fechaInicio), moment(fechaFin), 'day', '[]');

        let ejercicio = (seleccionables.Ejercicios || []).find(dentro);
        let semanas = (seleccionables.Semanas || []).filter(({ value, ejercicioID }) => value !== null &&
            (!ejercicio || Number(ejercicioID) === Number(ejercicio.value)));
        let semana = semanas.find(dentro);
        if (!semana) return "";

        return String(semana.numSemana);
    }

    function semanasDelEjercicio(ejercicioID) {
        let semanas = seleccionables.Semanas ? seleccionables.Semanas : [];
        if (!ejercicioID || semanas.some(({ value }) => value === null)) return semanas;
        return semanas.filter(({ ejercicioID: ejercicioSemana }) => Number(ejercicioSemana) === Number(ejercicioID));
    }

    function ftErrorInputText({ condicion, ref, keyError, mensajeError }) {
        return handleErrorInputText({
            cleanErrorState, condicion, ref, keyError, mensajeError,
            loader: setLoader, disabled: setDisabled, errorState: setErrorState
        });
    }

    function ftErrorInputTextSemanal({ condicion, ref, keyError, mensajeError }) {
        return handleErrorInputText({
            cleanErrorState: cleanErrorStateSemanal, condicion, ref, keyError, mensajeError,
            loader: setLoaderSemanal, disabled: setDisabledSemanal, errorState: setErrorStateSemanal
        });
    }

    function handleChange(value, key) {
        setState(stDatos => ({ ...stDatos, [key]: value }));
        setErrorState(errorState => ({ ...errorState, [key]: { error: false, helperText: "" } }));
    }


    function handleChangeSemanal(value, key) {
        setStateSemanal(stSemanal => ({ ...stSemanal, [key]: value }));
        setErrorStateSemanal(errorStateSemanal => ({ ...errorStateSemanal, [key]: { error: false, helperText: "" } }));
    }

    function handleValidaciones({ personalSeguimiento, tipoSeguimientoID, empresaID, ejercicioID, estadoID, fechaIngreso }) {
        let error;
        let validaciones = [
            {
                condicion: !tipoSeguimientoID,
                ref: tipoSeguimientoIDRef, keyError: "tipoSeguimientoID",
                mensajeError: "Debe especificar la categoría"
            },
            {
                condicion: !empresaID,
                ref: empresaIDRef, keyError: "empresaID",
                mensajeError: "Debe especificar la empresa"
            },
            {
                condicion: trim(personalSeguimiento || "").length > 100,
                ref: null, keyError: "personalSeguimiento",
                mensajeError: "El personal de seguimiento no debe exceder de 100 caracteres"
            },
            {
                condicion: !ejercicioID,
                ref: ejercicioIDRef, keyError: "ejercicioID",
                mensajeError: "Debe especificar el ejercicio"
            },
            {
                condicion: !estadoID,
                ref: estadoIDRef, keyError: "estadoID",
                mensajeError: "Debe especificar el estado"
            },
            {
                condicion: !fechaIngreso || !moment(fechaIngreso).isValid(),
                ref: null, keyError: "fechaIngreso",
                mensajeError: "Debe especificar la fecha de ingreso"
            }
        ];

        validaciones.forEach(({ condicion, ref, keyError, mensajeError }) => {
            if (error) return;
            error = ftErrorInputText({ condicion, ref, keyError, mensajeError });
        });

        if (error) return error;
    }

    function handleValidacionesSemanal({ avance, avanceRestante, fechaSeguimiento, comentario }) {
        let error;
        let fueraDeRango = !fechaSeguimiento || !moment(fechaSeguimiento).isValid() || !stFechaInicialPadre
            || moment(fechaSeguimiento).isBefore(moment(stFechaInicialPadre), 'day');
        let porcentaje = avance === "" || avance === null || avance === undefined ? NaN : Number(avance);
        let validaciones = [
            {
                condicion: fueraDeRango,
                ref: null, keyError: "fechaSeguimiento",
                mensajeError: stFechaInicialPadre
                    ? `La fecha de seguimiento no puede ser anterior a la fecha de ingreso (${moment(stFechaInicialPadre).format("DD/MM/YYYY")})`
                    : "El seguimiento no tiene fecha de ingreso"
            },
            {
                // Los que vienen del seguimiento del reporte o reclamo pueden quedarse con 0%
                condicion: isNaN(porcentaje) || porcentaje < 0 || (porcentaje === 0 && !stSemanal.seguimientoOrigenID),
                ref: null, keyError: "avance",
                mensajeError: "El porcentaje de gestión debe ser mayor a 0"
            },
            {
                condicion: porcentaje > avanceRestante,
                ref: null, keyError: "avance",
                mensajeError: `El porcentaje de gestión no puede ser mayor al restante del seguimiento (${avanceRestante}%)`
            },
            {
                condicion: !comentario || comentario.trim() === "",
                ref: comentarioRef, keyError: "comentario",
                mensajeError: "Debe especificar el seguimiento"
            }
        ];

        validaciones.forEach(({ condicion, ref, keyError, mensajeError }) => {
            if (error) return;
            error = ftErrorInputTextSemanal({ condicion, ref, keyError, mensajeError });
        });

        if (error) return error;
    }

    function ftGuardar() {
        async function ftGuardar() {
            let {
                seguimientoSiniestroID, tipoSeguimientoID, empresaID, ejercicioID,
                semanaAltaID, estadoID, usuarioID, responsableID, personalSeguimiento, folio, numSiniestro, bienDaniado, descripcion,
                montoReclamado, fechaDanio, fechaReclamacion, fechaAlta, fechaIngreso, fechaSeguimiento, numContacto, avance, origenID, origenTipo
            } = stDatos;

            let error = await handleValidaciones({ personalSeguimiento, tipoSeguimientoID, empresaID, ejercicioID, estadoID, fechaIngreso });
            if (error) return error;

            let input = {
                tipoSeguimientoID: parseInt(tipoSeguimientoID),
                empresaID: parseInt(empresaID),
                ejercicioID: parseInt(ejercicioID),
                semanaAltaID: semanaAltaID ? parseInt(semanaAltaID) : null,
                estadoID: parseInt(estadoID),
                usuarioID: usuarioID ? parseInt(usuarioID) : null,
                responsableID: responsableID ? parseInt(responsableID) : null,
                personalSeguimiento: trim(personalSeguimiento || "") || null,
                folio: trim(folio || ""),
                numSiniestro: trim(numSiniestro || ""),
                bienDaniado: trim(bienDaniado || ""),
                descripcion: trim(descripcion || ""),
                montoReclamado: formatearImporte(montoReclamado),
                fechaDanio: formatearFecha(fechaDanio) || formatearFecha(moment()),
                fechaReclamacion: formatearFecha(fechaReclamacion),
                fechaAlta: formatearFecha(fechaAlta),
                fechaIngreso: formatearFecha(fechaIngreso),
                fechaSeguimiento: formatearFecha(fechaSeguimiento) || formatearFecha(fechaIngreso),
                numContacto: trim(numContacto || ""),
                avance: avance === "" ? 0 : parseFloat(avance),
                origenID: origenID ? parseInt(origenID) : null,
                origenTipo: origenID ? (origenTipo || null) : null
            };

            if (seguimientoSiniestroID) {
                await updateSeguimientoSiniestros({ input: { ...input, seguimientoSiniestroID } }, token);
            } else {
                await addSeguimientoSiniestros({ input }, token);
            }
        }
        return ftGuardar();
    }

    function ftGuardarSemanal() {
        async function ftGuardarSemanal() {
            let {
                seguimientoSemanalSinID, avance,
                fechaSeguimiento, personalSeguimiento, comentario
            } = stSemanal;

            let semanales = await getAllSeguimientoSemanalSin({ filtro: { seguimientoSiniestroID: Number(stSeguimientoSiniestroID) } }, token);
            let avanceOtros = (Array.isArray(semanales) ? semanales : [])
                .filter(({ seguimientoSemanalSinID: id }) => String(id) !== String(seguimientoSemanalSinID))
                .reduce((total, { avance: avanceSemanal }) => total + (Number(avanceSemanal) || 0), 0);
            let avanceRestante = Math.max(0, Math.round((100 - avanceOtros) * 100) / 100);

            let error = await handleValidacionesSemanal({ avance, avanceRestante, fechaSeguimiento, comentario });
            if (error) return error;

            let input = {
                seguimientoSiniestroID: parseInt(stSeguimientoSiniestroID),
                avance: avance === "" ? 0 : parseFloat(avance),
                fechaSeguimiento: formatearFecha(fechaSeguimiento),
                personalSeguimiento: trim(personalSeguimiento || ""),
                comentario: trim(comentario || "")
            };

            if (seguimientoSemanalSinID) {
                await updateSeguimientoSemanalSin({ input: { ...input, seguimientoSemanalSinID } }, token);
            } else {
                await addSeguimientoSemanalSin({ input }, token);
            }

            setActualizar(!actualizar);
        }
        return ftGuardarSemanal();
    }

    function formatearFecha(pFecha) {
        if (!pFecha || moment(pFecha).isValid() === false) return null;
        return moment(pFecha).format("YYYY-MM-DD");
    }

    function formatearImporte(pImporte) {
        if (pImporte === "" || pImporte === null || pImporte === undefined) return null;
        let importe = parseFloat(pImporte);
        return isNaN(importe) ? null : importe;
    }

    function handleClose() {
        setOpen(false);
        setDisabled(false);
        setLoader(false);
        setNotificaciones({ ...cleanNotificaciones });
        setState({ ...cleanState });
        setErrorState({ ...cleanErrorState });
    }

    function handleCloseSemanal() {
        setDisabledSemanal(false);
        setLoaderSemanal(false);
        if (!openVerSemanal) return handleCloseVerSemanal();
        setOpenSemanal(false);
        setNotificacionesSemanal({ ...cleanNotificaciones });
        setStateSemanal({ ...cleanStateSemanal });
        setErrorStateSemanal({ ...cleanErrorStateSemanal });
    }

    function handleCloseVerSemanal() {
        setOpenVerSemanal(false);
        setSeguimientoSiniestroID(-1);
        setFolio("");
        setFechaInicialPadre("");
        setFechaFinalPadre("");
        setStateSemanal({ ...cleanStateSemanal });
        setOpenSemanal(false);
        setNotificacionesSemanal({ ...cleanNotificaciones });
        setErrorStateSemanal({ ...cleanErrorStateSemanal });
    }

    useEffect(() => {
        async function ftEffect() {
            try {
                let Empresas = await seleccionEmpresa({}, token);
                let Usuarios = await seleccionUsuarios({ filtro: {} }, token);
                let Responsables = await seleccionResponsablesSeguro({ filtro: {} }, token);
                let Ejercicios = await seleccionEjercicioSiniestros({ filtro: {} }, token);
                let Semanas = await seleccionSemanaSiniestros({ filtro: {} }, token);
                let Estados = await seleccionEstadoSeguimientoSin({ filtro: {} }, token);
                let Tipos = await seleccionTipoSeguimientoSin({ filtro: {} }, token);
                setSeleccionables({ Empresas, Usuarios, Responsables, Ejercicios, Semanas, Estados, Tipos });

                let [primerEstado] = Estados.filter(({ value }) => value !== null);
                setActuales({
                    ...ftVigentesALaFecha(Ejercicios, Semanas),
                    estadoID: primerEstado ? primerEstado.value : ""
                });
            } catch ({ message }) {
                setAlert({
                    descripcion: `Algunos datos necesarios para funcionar no se cargaron correctamente, intenta actualizar la página o verifica tu conexión a internet; a continuación se muestrán más detalles del error: ${NetworkError(message)}`,
                    title: "¡Una disculpa!",
                    tipo: danger,
                    msjConfirmacion: "Aceptar",
                    onConfirm: () => setAlert(null),
                    showCancel: false
                });
            } finally {
                setCatalogosListos(true);
            }
        } ftEffect();
    }, []);

    const [accionesUsr, setAccionesUsr] = useState();
    if (accionesUsr) {
        acciones = Permisos.ValidarAcciones(acciones, accionesUsr);
        botones = Permisos.ValidarAcciones(botones, accionesUsr);
        accionesFormulario = Permisos.ValidarAcciones(accionesFormulario, accionesUsr);
    } else {
        Permisos.PermisosAState(setAccionesUsr, token);
    }

    const formularioSemanal = <FormularioModal
        open={openSemanal}
        title={titleModalSemanal}
        onClose={handleCloseSemanal}
        notificaciones={notificacionesSemanal}
        closeNotification={() => setNotificacionesSemanal({ ...cleanNotificaciones })}
        inputs={inputsSemanal}
        acciones={accionesFormularioSemanal}
        focus={comentarioRef}
    />;

    return (<>
        {stCatalogosListos && <Tabla
            infoTabla={infoTabla}
            asyncData={ftTablaSeguimientos}
            token={token}
        />}
        <FormularioModal
            open={open}
            title={titleModal}
            onClose={handleClose}
            notificaciones={notificaciones}
            closeNotification={() => setNotificaciones({ ...cleanNotificaciones })}
            inputs={inputs}
            acciones={accionesFormulario}
            focus={empresaIDRef}
        />
        {stBuscarReclamo && <Modal
            maxWidth={true}
            open={Boolean(stBuscarReclamo)}
            title={`Buscar ${camposReclamo[stBuscarReclamo].titulo}`}
            onClose={() => setBuscarReclamo(null)}
        >
            <Tabla
                key={stBuscarReclamo}
                infoTabla={ftInfoTablaReclamos(stBuscarReclamo)}
                asyncData={camposReclamo[stBuscarReclamo].asyncData}
                token={token}
                parametrosFijos={{
                    fechaIni: "2000-01-01T00:00:00",
                    fechaFin: "2100-12-31T23:59:59",
                    ...(stDatos.empresaID ? { empresaID: Number(stDatos.empresaID) } : {})
                }}
            />
        </Modal>}
        {openVerSemanal && <Modal
            maxWidth={true}
            open={openVerSemanal}
            title={`Historial de Seguimiento ${stFolio ? "(" + stFolio + ")" : ""}`}
            onClose={handleCloseVerSemanal}
        >
            <Tabla
                infoTabla={infoTablaSemanal}
                asyncData={tablaSeguimientoSemanalSin}
                token={token}
                parametrosFijos={{ seguimientoSiniestroID: stSeguimientoSiniestroID }}
            />
            {formularioSemanal}
        </Modal>}
        {!openVerSemanal && formularioSemanal}
        {alert && <SweetAlert
            title={alert.title}
            descripcion={alert.descripcion}
            tipo={alert.tipo}
            msjConfirmacion={alert.msjConfirmacion}
            msjCancelacion={alert.msjCancelacion}
            onConfirm={alert.onConfirm}
            showConfirm={alert.showConfirm}
            showCancel={alert.showCancel}
            onCancel={() => setAlert(null)}
        />}
    </>);
}

export default SeguimientoSiniestros;
